import { createContext, useContext } from 'react';

export interface AuthState {
  /** 'initializing' until the persisted-session check settles. */
  status: 'initializing' | 'signedOut' | 'signedIn';
  /** The realm claim — the canonical tenant header. Set only when signedIn. */
  tenant: string | null;
  email: string | null;
  /** Prefill for the sign-in form (last successfully typed tenant key). */
  lastTenant: string;
  signIn: (tenant: string, email: string, password: string) => Promise<void>;
  /** Dashboard handoff: swap a one-time code for a real session. See auth/handoff.ts. */
  signInWithHandoff: (code: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
